"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Card = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Card, _Component);

  function Card() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Card)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "forceUnlinked", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "isPurchaseTile", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "showTypeLabel", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "attributes", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "showButton", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "linkTarget", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "typeLabel", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "image", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "objectTitle", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "promoText", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "objectListingSummary", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "isCurrentObject", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "pricingOptions", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "purchaseInfo", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "scaleImage", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(Card, [{
    key: "feedbackBadge",
    value: function feedbackBadge(value) {
      if (!value) return null;
      if (value < 10) return _react.default.createElement("div", {
        key: "feedbackBadge",
        className: "feedback-badge",
        "data-count": value
      });
      return _react.default.createElement("div", {
        key: "feedbackBadge",
        className: "feedback-badge overflowed",
        "data-count": value
      });
    }
  }, {
    key: "renderPerson",
    value: function renderPerson(person) {
      return [person.photo && _react.default.createElement("div", {
        className: "image",
        key: "image",
        style: {
          backgroundImage: "url(".concat(person.photo, ")")
        }
      }), _react.default.createElement("p", {
        key: "name"
      }, person.name, person.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, person.icons.map(function (icon) {
        return _react.default.createElement("img", {
          className: "account-icon",
          key: icon.id,
          src: "/t/width=75/height=75/matte=fff0/scale/f".concat(icon.icon, "/icon.png"),
          title: icon.title
        });
      }))), person.title && _react.default.createElement("p", {
        className: "person-title",
        key: "title"
      }, person.title)];
    }
  }, {
    key: "render",
    value: function render() {
      var Node = 'a';

      if (this.forceUnlinked) {
        Node = 'div';
      }

      return _react.default.createElement(Node, _extends({}, this.attributes, {
        "data-is-current-page": this.isCurrentPage
      }), _react.default.createElement("div", {
        className: "top"
      }, this.renderImage(), this.showTypeLabel && this.typeLabel && _react.default.createElement("div", {
        className: "type"
      }, this.typeLabel), this.renderAdditionalTopItems()), _react.default.createElement("div", {
        className: "middle without-bottom"
      }, this.renderTileContainer()), this.renderAdditionalTileContents());
    }
  }, {
    key: "renderTileContainer",
    value: function renderTileContainer() {
      return _react.default.createElement("div", {
        className: "inner-content"
      }, this.showTypeLabel && this.typeLabel && _react.default.createElement("div", {
        className: "type"
      }, this.typeLabel), this.renderTileBody(), this.renderBottomContentWrapper(), this.renderTileFooter());
    }
  }, {
    key: "renderImage",
    value: function renderImage() {
      return _react.default.createElement("div", {
        className: "image",
        style: {
          backgroundImage: "url(".concat(this.scaleImage ? "/t/width=400/matte=none/scale/f".concat(this.image, "/image.jpg") : this.image, ")")
        }
      });
    }
  }, {
    key: "renderAdditionalTopItems",
    value: function renderAdditionalTopItems() {
      return null;
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      var r = [_react.default.createElement("h3", {
        key: "title"
      }, this.objectTitle)];

      if (this.isPurchaseTile) {
        if (this.objectListingSummary) {
          r.push(_react.default.createElement("p", {
            className: _classList.default.join(this.objectListingClasses, this.isCurrentObject && 'promoText'),
            key: "summary"
          }, this.objectListingSummary));
        }
      } else {
        if (this.promoText && this.objectListingSummary != this.promoText) {
          r.push(_react.default.createElement("p", {
            key: "promoText",
            className: this.isCurrentObject ? 'promoText' : void 0
          }, this.promoText));
        }

        if (this.objectListingSummary) r.push(_react.default.createElement("p", {
          key: "summary",
          className: this.objectListingClasses
        }, this.objectListingSummary));
      }

      return _react.default.createElement.apply(_react.default, [_react.Fragment, {}].concat(r));
    }
  }, {
    key: "renderBottomContentWrapper",
    value: function renderBottomContentWrapper() {
      var r = this.renderBottomContent();
      if (r) return _react.default.createElement("div", {
        className: "bottom-content"
      }, r);
      return null;
    }
  }, {
    key: "formatPrice",
    value: function formatPrice() {
      var info = this.purchaseInfo;
      return [info.priceText ? _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: info.priceText
        },
        key: "price-text"
      }) : null, info.freeText ? _react.default.createElement("div", {
        className: "freeTrial",
        dangerouslySetInnerHTML: {
          __html: info.freeText
        },
        key: "free-text"
      }) : null].filter(function (v) {
        return !!v;
      });
    }
  }, {
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile) {
        return [_react.default.createElement("div", {
          key: "price",
          className: "price"
        }, this.formatPrice()), _react.default.createElement("div", {
          key: "purchase",
          className: "purchase"
        }, this.pricingOptions && this.pricingOptions.length && _react.default.createElement("a", _extends({
          className: "btn btn-primary buy-button"
        }, this.courseSession ? {
          'data-session': this.courseSession
        } : {}, {
          "data-target": this.id,
          "data-price": this.pricingOptions[0].type,
          href: this.linkTarget
        }), "Select"), _react.default.createElement("a", {
          className: "small-details",
          href: this.linkTarget
        }, "Learn More"))];
      }

      return null;
    }
  }, {
    key: "renderTileFooter",
    value: function renderTileFooter() {
      return null;
    }
  }, {
    key: "renderAdditionalTileContents",
    value: function renderAdditionalTileContents() {
      return null;
    }
  }], [{
    key: "makeDefaultCardType",
    value: function makeDefaultCardType(typeId, typeLabel) {
      var _class3, _descriptor17, _class4, _temp2;

      var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : typeId;
      var showPerson = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var pageId = typeId.charAt(0).toUpperCase() + typeId.substring(1) + 'Detail';
      return _class3 = (_temp2 = _class4 =
      /*#__PURE__*/
      function (_this2) {
        babelHelpers.inherits(_class3, _this2);

        function _class3() {
          var _babelHelpers$getProt2;

          var _this3;

          babelHelpers.classCallCheck(this, _class3);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(_class3)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
          babelHelpers.initializerDefineProperty(_this3, "person", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
          return _this3;
        }

        babelHelpers.createClass(_class3, [{
          key: "renderBottomContent",
          value: function renderBottomContent() {
            if (!showPerson || this.isPurchaseTile) return babelHelpers.get(babelHelpers.getPrototypeOf(_class3.prototype), "renderBottomContent", this).call(this);
            if (showPerson && this.person) return this.renderPerson(this.person);
            return null;
          }
        }], [{
          key: "tileClassList",
          value: function tileClassList(object, page, options) {
            return "".concat(babelHelpers.get(babelHelpers.getPrototypeOf(_class3), "tileClassList", this).call(this, object, page, options), " ").concat(className);
          }
        }, {
          key: "card",
          value: function card(object, page, options) {
            return Object.assign(babelHelpers.get(babelHelpers.getPrototypeOf(_class3), "card", this).call(this, object, page, options), {
              typeLabel: typeLabel
            }, showPerson ? this.getPerson(object, page, options) : {});
          }
        }, {
          key: "tilePageId",
          value: function tilePageId() {
            return pageId;
          }
        }]);
        return _class3;
      }(this), _class4.defaultImageId = "default".concat(typeId.charAt(0).toUpperCase()).concat(typeId.substring(1), "ListItemImage"), _temp2), (_descriptor17 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "person", [_decorators.prop], {
        configurable: true,
        enumerable: true,
        writable: true,
        initializer: null
      })), _class3;
    }
  }]);
  return Card;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "forceUnlinked", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "isPurchaseTile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "showTypeLabel", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "attributes", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "showButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linkTarget", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "typeLabel", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "objectTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "promoText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "objectListingSummary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "isCurrentObject", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "pricingOptions", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "purchaseInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "scaleImage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);
exports.default = Card;